import { render, staticRenderFns } from "./ModalGroupComponent.vue?vue&type=template&id=4dd240eb"
import script from "./ModalGroupComponent.vue?vue&type=script&lang=js"
export * from "./ModalGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports